import styled from 'styled-components';

import { media } from 'legacyComponents/styled/styleUtils';
import { Banner, Button } from 'components';

export const SmallPrint = styled.span`
  font-size: ${props => props.theme.font.size.small};
`;

export const DowngradeText = styled.span`
  color: ${props => props.theme.color.wfOrange};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const UpgradeText = styled(DowngradeText)`
  color: ${props => props.theme.color.primary};
`;

export const UpgradeCta = styled.div`
  width: 100%;
  border: 1px solid ${props => props.theme.color.wfGrey200};
  border-radius: ${props => props.theme.borderRadius.small};
  background-color: ${props => props.theme.color.wfGrey100};
  padding: 30px;
  position: relative;
  > p:nth-of-type(1) {
    line-height: 1.4;
  }
  > p:nth-of-type(2) {
    margin: 10px 0 0 0;
    font-size: ${props => props.theme.font.size.small};
    line-height: 1.4;
    > a {
      color: ${props => props.theme.color.primary};
      text-decoration: underline;
    }
  }
  ${media.m`
    padding: 20px;
  `};
`;

export const ButtonStyled = styled(Button)`
  margin: 0 ${props => props.theme.spacing.small};
`;

export const UpgradeCtaButton = styled(Button)`
  position: absolute;
  top: 30px;
  right: 30px;
  ${media.m`
    position: initial;
    float: none;
    margin-top: 20px;
  `};
`;

export const Table = styled.table`
  width: 100%;
  text-align: left;
  font-size: ${props => props.theme.font.size.default};
  border: 1px solid ${props => props.theme.color.wfBlack};
  overflow: hidden;
  border-collapse: collapse;
`;

export const THead = styled.thead`
  vertical-align: middle;
`;

export const Th = styled.th`
  padding: ${props => props.theme.spacing.small};
  border: 1px solid ${props => props.theme.color.wfBlack};
  text-align: ${props => (props.center ? 'center' : 'left')};
`;

export const Td = styled.td.attrs(props => ({
  colSpan: props.category ? 5 : 1,
}))`
  padding: ${props => props.theme.spacing.small};
  color: ${props => props.theme.color.wfBlack};
  text-align: ${props => (props.center ? 'center' : 'left')};
  border: 1px solid ${props => props.theme.color.wfBlack};
`;

export const CheckoutItem = styled.div`
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  margin-bottom: ${props => (props.last ? '0' : '20px')};
  padding-bottom: 20px;
  > h3 {
    > span {
      font-size: ${props => props.theme.font.size.small};
      float: right;
    }
  }
  > h4 {
    margin: 0 0 5px 0;
    > span {
      font-size: ${props => props.theme.font.size.small};
      float: right;
      margin-top: 10px;
    }
  }
  > p {
    font-size: ${props => props.theme.font.size.small};
    display: inline-block;
  }
`;

export const TogglePriceDetails = styled.p`
  float: ${props => props.float || 'right'};
  font-size: ${props => props.theme.font.size.small};
  color: ${props => props.theme.color.primary};
  text-decoration: underline;
  cursor: pointer;
  display: ${props => (props.visible ? 'inline-block' : 'none !important')};
`;

export const PriceDetailsWrapper = styled.div`
  display: inline-block;
  width: 100%;
`;

export const PriceDetails = styled.div`
  border: 1px solid ${props => props.theme.color.wfGrey200};
  border-radius: ${props => props.theme.borderRadius.small};
  background-color: ${props => props.theme.color.wfGrey100};
  margin: 0 0 ${props => props.theme.spacing.default} 0;
  padding: ${props => props.theme.spacing.default};
  position: relative;
  > p {
    font-size: ${props => props.theme.font.size.small};
    font-weight: bold;
    > span {
      float: right;
    }
    a {
      color: ${props => props.theme.color.primary};
      text-decoration: underline;
    }
  }
  > p:not(:first-child):last-of-type {
    margin: 15px 0 10px 0;
  }
  > ul {
    font-size: ${props => props.theme.font.size.small};
    color: rgba(0, 0, 0, 0.7);
    padding: 0 0 0 ${props => props.theme.spacing.default};
    margin-top: ${props => props.theme.spacing.small};
    > li {
      margin-bottom: ${props => props.theme.spacing.xsmall};
      > span {
        float: right;
      }
    }
    > li:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const AddPaymentMethodLink = styled.p`
  color: ${props =>
    props.danger ? props.theme.color.wfOrange : props.theme.color.primary};
  text-decoration: underline;
  cursor: pointer;
  font-size: ${props => props.theme.font.size.small};
  display: inline;
`;

export const CouponStyle = styled.p`
  font-size: ${props => props.theme.font.size.small};
  color: ${props => props.theme.color.primary};
  text-decoration: underline;
  text-align: right;
  cursor: pointer;
  margin: 10px 0 0 0;
`;

export const BannerStyled = styled(Banner)`
  /* FIXME: Keeping all styles for not changing the layout. Move Banner directly to subscription/checkou.js without styles once payments can be refactored */
  margin-bottom: 20px;
  margin-top: -5px;
`;

export const PlanDescriptionWrapper = styled.div`
  margin: 0 0 20px 20px;
`;

export const AssignedStats = styled.span`
  float: right;
  color: ${props => props.theme.color.wfGrey900};
`;

export const TotalSeatsBar = styled.div`
  width: 100%;
  height: 20px;
  border-radius: 20px;
  background-color: ${props => props.theme.color.wfGrey100};
  border: 1px solid ${props => props.theme.color.wfGrey300};
  margin-bottom: 30px;
`;

export const BarItem = styled.div`
  display: inline-block;
  width: calc((100% / ${props => props.totalBarItems}));
  height: 100%;
  background-color: ${props =>
    props.active ? props.theme.color.primary : props.theme.color.wfGrey200};
  border-right: ${props =>
    props.last ? 'none' : `1px solid ${props.theme.color.wfWhite}`};
  border-top-left-radius: ${props => (props.first ? '20px' : '0')};
  border-bottom-left-radius: ${props => (props.first ? '20px' : '0')};
  border-top-right-radius: ${props => (props.last ? '20px' : '0')};
  border-bottom-right-radius: ${props => (props.last ? '20px' : '0')};
`;

export const BarKey = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: ${props =>
    props.active ? props.theme.color.primary : props.theme.color.wfGrey200};
  margin-right: 5px;
  margin-left: 10px;
  display: inline-block;
  border: 1px solid
    ${props =>
      props.active ? props.theme.color.primary : props.theme.color.wfGrey300};
`;

export const SeatsFormWrapper = styled.div`
  width: 100%;
  border: 1px solid ${props => props.theme.color.wfGrey200};
  padding: 0 20px 20px;
`;

export const SeatsFormItem = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
`;

export const SeatsFormItemTitle = styled.div`
  flex-grow: 1;
`;

export const SeatsFormItemValue = styled.div`
  flex-grow: 1;
  text-align: right;
`;

export const Sign = styled.span`
  margin-right: 10px;
  color: ${props =>
    props.red ? props.theme.color.wfOrange : props.theme.color.primary};
`;

export const SeatInput = styled.input`
  color: ${props => props.theme.color.wfGrey900};
  border: 1px solid
    ${props =>
      props.error ? props.theme.color.wfOrange : props.theme.color.wfGrey200};
  text-align: right;
  &:focus {
    outline: 0;
    border: 1px solid
      ${props =>
        props.error ? props.theme.color.wfOrange : props.theme.color.wfGrey400};
  }
`;

export const SmallSeatInput = styled(SeatInput)`
  margin-left: 5px;
  width: 40px;
`;

export const MaximumRemove = styled.p`
  font-size: 0.7em;
  margin: 5px 0 0 0;
  color: ${props => (props.error ? props.theme.color.wfOrange : `inherit`)};
`;

// FIXME - temporary solution in replacement of p
export const AssignedSeatsInfo = styled.div`
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0;
  margin-inline-end: 0;
`;
